(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curiosa-question-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('curiosa-question-reviews')) {
    customElements.define('curiosa-question-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const cards = [...this.querySelectorAll('[data-cqr-card]')];
        const dots = [...this.querySelectorAll('.cqr__dot')];
        const counter = this.querySelector('[data-cqr-count]');
        let index = 0;
        const show = next => {
          if (!cards.length) return;
          index = (next + cards.length) % cards.length;
          cards.forEach((card, i) => { card.hidden = i !== index; });
          dots.forEach((dot, i) => dot.classList.toggle('is-current', i === index));
          if (counter) counter.textContent = `${index + 1} / ${cards.length}`;
        };
        this.querySelector('[data-cqr-prev]')?.addEventListener('click', () => show(index - 1), options);
        this.querySelector('[data-cqr-next]')?.addEventListener('click', () => show(index + 1), options);
        const deck = this.querySelector('.cqr__deck');
        let touch = null;
        deck?.addEventListener('touchstart', event => {
          const point = event.changedTouches[0];
          touch = { x: point.clientX, y: point.clientY };
        }, { ...options, passive:true });
        deck?.addEventListener('touchend', event => {
          if (!touch) return;
          const point = event.changedTouches[0];
          const dx = point.clientX - touch.x, dy = point.clientY - touch.y;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
          touch = null;
        }, { ...options, passive:true });
        deck?.addEventListener('touchcancel', () => { touch = null; }, options);
        this.addEventListener('shopify:block:select', event => {
          const selected = cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (selected >= 0) show(selected);
        }, options);
        const findWidget = () => {
          let sibling = this.closest('.shopify-section')?.nextElementSibling;
          while (sibling) {
            const widget = sibling.querySelector('.jdgm-rev-widg');
            if (widget) return widget;
            sibling = sibling.nextElementSibling;
          }
          return null;
        };
        this.querySelector('[data-cqr-write]')?.addEventListener('click', () => {
          const widget = findWidget();
          const link = widget?.querySelector('.jdgm-write-rev-link');
          if (link) {
            link.click();
            requestAnimationFrame(() => {
              const form = widget.querySelector('.jdgm-form-wrapper');
              (form || widget).scrollIntoView({ behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
            });
          } else if (widget) widget.scrollIntoView({ block:'center' });
        }, options);
        const translateLink = () => {
          const link = findWidget()?.querySelector('.jdgm-row-readmore .jdgm-btn');
          if (link && link.textContent.trim() !== this.dataset.moreLabel) link.textContent = this.dataset.moreLabel;
        };
        if (this.dataset.reviewScope !== 'none') {
          this.observer = new MutationObserver(translateLink);
          this.observer.observe(this.closest('main') || document.body, { childList:true, subtree:true });
          translateLink();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
